/* import __COLOCATED_TEMPLATE__ from './address-input-type-form-old.hbs.js'; */
var _dec, _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { tagName } from '@ember-decorators/component';
import AddressInputTypeForm from './address-input-type-form';
let AddressInputTypeFormOld = (_dec = tagName(''), _dec(_class = class AddressInputTypeFormOld extends AddressInputTypeForm {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "useMarketUI", false);
  }
}) || _class);
export { AddressInputTypeFormOld as default };